export const modal = {
    state: {
        modalState: {
            show: false,
            showOld: false,
            content: 'ModalEmpty',
            args: {},
            classes: null
        },
        modal: null,
        prevStates: []
    },
    mutations: {
        TOGGLE_MODAL(state, payload) {
            state.modal = payload
        },
        SET_CONTENT(state, content) {
            state.modalState.content = content
        },
        SET_ARGS(state, args) {
            state.modalState.args = args
        },
        SET_CLASSES(state, classes) {
            state.modalState.classes = classes
        },
        PUSH_STATE(state, pushedState) {
            state.prevStates.push(pushedState)
        },
        SHIFT_STATE(state) {
            state.prevStates.shift()
        },
        TOGGLE_MODAL_OLD(state, show) {
            state.modalState.showOld = show
        }
    },
    actions: {
        toggleModal({ commit, dispatch }, show) {
            commit('TOGGLE_MODAL', show)
            commit('TOGGLE_MODAL_OLD', show)
            // save to history
            if (!show) {
                dispatch('addToModalHistory', {
                    show: false,
                    content: 'ModalEmpty',
                    args: {}
                })
            }
        },
        /**
         * load modal template
         * @param {object} state  vuex state
         * @param {object} payload - mutation args
         */
        loadContent({ state, dispatch, commit }, payload) {
            commit('SET_CONTENT', 'ModalEmpty')

            // document.getElementById('baseModal').scrollTop = 0
            commit('SET_CONTENT', payload.component)
            commit('SET_ARGS', payload.args)
            commit('SET_CLASSES', payload.classes)
            // save to history
            dispatch('addToModalHistory', {
                show: state.modalState.show,
                content: payload.component,
                args: payload.args
            })
        },
        async openModal({ state, commit, dispatch }, payload) {
            if (state.modal) {
                // If other modal is open, close it
                await dispatch('toggleModal', false)
            }

            if (payload.componentPath) {
                if (state.modalState.showOld) {
                    commit('TOGGLE_MODAL_OLD', false)
                }

                commit('TOGGLE_MODAL', payload)
                dispatch('loadContent', payload)
                return
            }
            commit('TOGGLE_MODAL_OLD', true)
            dispatch('loadContent', payload)
        },
        addToModalHistory({ commit, getters }, pushedState) {
            commit('PUSH_STATE', pushedState)
            if (getters.prevStates.length > 10) {
                commit('SHIFT_STATE')
            }
        }
    },
    getters: {
        getModal: (state) => {
            return state.modal
        },
        modalState: (state) => {
            return state.modalState
        },
        prevStates: (state) => {
            return state.prevStates
        },
        isModalOn: (state) => {
            return state.modalState.show || state.modalState.showOld
        }
    }
}
